import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import DevGuard from "./components/DevGuard";
import AdminThemeScope from "./components/admin/AdminThemeScope";
import { AuthProvider } from "./contexts/AuthContext";
import { AIChatProvider } from "./contexts/AIChatContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AIChatProvider>
          <DevGuard />
          <AdminThemeScope />
          <Routes />
        </AIChatProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
